import Country from '~/Api/Country/Country';

import ReferenceBasketVersion from './ReferenceBasketVersion';

interface RawReferenceBasketVersion {
	id: string;
	description: string;
	sinceDate: string;
	referencedCountry: Country;
	referenceCountries: Country[];
}

export default function mapReferenceBasketVersion(version: RawReferenceBasketVersion): ReferenceBasketVersion {
	return new ReferenceBasketVersion(
		version.id,
		version.description,
		new Date(version.sinceDate),
		new Country(version.referencedCountry.alpha2, version.referencedCountry.name),
		version.referenceCountries.map((country) => new Country(country.alpha2, country.name))
	);
}
